<template>
  <div>
    <TextInputConfiguration
      :controller="OrderStringCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
    />
    <TextInputConfiguration
      :controller="WindowStringCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
    />
  </div>
</template>

<script>
import {inputTextConfCtrller} from '@/assets/classes/configuration.js'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import TextInputConfiguration from '@/components/properties/elements/TextInputConfiguration'

export default {
  name: 'SavitzkyGolay',
  components:{
    TextInputConfiguration,
  },
  props: {
    sectionconfig:{
      type:String,
      required:true
    }
  },
  data() {
    return {
      elementsConfig:[],
      OrderStringCtrller: new inputTextConfCtrller(ConfigName.OrderSavitzkyGolayPreProc,'Order','Please give a numerical value greater than zero','1',(value)=>{return !isNaN(value)&& value>0}),
      WindowStringCtrller: new inputTextConfCtrller(ConfigName.WindowSavitzkyGolayPreProc,'Window','Please give a numerical value greater than zero','1',(value)=>{return !isNaN(value)&& value>0}),
    }
  },
  mounted(){
    this.elementsConfig = [
      this.OrderStringCtrller,
      this.WindowStringCtrller
    ]
    this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
    this.elementsConfig.forEach(conf=>conf.setParent(this))
  },
}
</script>

<style>
